const config = {
  authority: 'https://localhost:44306',
  remoteUrl: 'https://localhost:44305'
};

export default config;
